import FormattedMessage from 'I18n/components/FormattedMessage';
import { FLOW_TYPES } from 'automation-ui-management/constants/CrmPropertyEnums';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const DescriptionsTooltip = ({
  children,
  disabled,
  description,
  flowType
}) => {
  const isActionSet = flowType === FLOW_TYPES.ACTION_SET;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: description || (isActionSet ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-management.DescriptionsTooltip.placeholder.actionSet"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-management.DescriptionsTooltip.placeholder.workflow"
    })),
    disabled: disabled,
    children: /*#__PURE__*/_jsx("div", {
      children: children
    })
  });
};
export default DescriptionsTooltip;